import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/complexRacersList.css';
// helpers
import ComplexRacer from '../components/complexRacer';
import ComplexBetButtons from '../components/complexBetButtons';
import {sortRacersByOddsFirst} from '../../../../modules/racing/helpers/racersHelper';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventId: state.vpp.selectedEventId,
        selectedEventIndex: state.vpp.selectedEventIndex
    };
};

class ComplexRacersList extends Component {
    constructor(props) {
        super(props);

        let store = props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState({
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex
        });
    }

    render() {
        let firstRacerColumnUI;
        let secondRacerColumnUI;
        let thirdRacerColumnUI;
        if (this.state.events && this.state.events.length) {
            let racers = this.state.events[this.state.selectedEventIndex].racers.slice();
            racers = racers.sort(sortRacersByOddsFirst);

            let oneHalfThough;
            let oneThirdThough;
            let arrayFirstColumn = [];
            let arraySecondColumn = [];
            let arrayThirdColumn = [];
            if (racers.length < 2) {
                arrayFirstColumn = racers.slice();
            } else if (racers.length === 2 || racers.length === 4 || racers.length === 8 || racers.length === 10) {
                oneHalfThough = Math.floor(racers.length / 2);
                arrayFirstColumn = racers.slice(0, oneHalfThough);
                arraySecondColumn = racers.slice(oneHalfThough, racers.length);
            } else {
                oneThirdThough = Math.floor(racers.length / 3);
                arrayFirstColumn = racers.slice(0, oneThirdThough);
                arraySecondColumn = racers.slice(oneThirdThough, oneThirdThough * 2);
                arrayThirdColumn = racers.slice(oneThirdThough * 2, racers.length);
            }

            firstRacerColumnUI = arrayFirstColumn.length
                ? arrayFirstColumn.map((racer, index) => {
                    return (<ComplexRacer store={this.props.store} racer={racer} key={index}/>);
                })
                : '';

            secondRacerColumnUI = arraySecondColumn.length
                ? arraySecondColumn.map((racer, index) => {
                    return (<ComplexRacer store={this.props.store} racer={racer} key={index}/>);
                })
                : '';

            thirdRacerColumnUI = arrayThirdColumn.length
                ? arrayThirdColumn.map((racer, index) => {
                    return (<ComplexRacer store={this.props.store} racer={racer} key={index}/>);
                })
                : '';

            firstRacerColumnUI = firstRacerColumnUI !== ''
                ? (<div className={style.racersColumn}>{firstRacerColumnUI}</div>)
                : '';
            secondRacerColumnUI = secondRacerColumnUI !== ''
                ? (<div className={style.racersColumn}>{secondRacerColumnUI}</div>)
                : '';
            thirdRacerColumnUI = thirdRacerColumnUI !== ''
                ? (<div className={style.racersColumn}>{thirdRacerColumnUI}</div>)
                : '';
        }
        return (<div className={style.complexRaceCard}>
            <div className={style.racersList}>
                <div className={style.racersListContent}>
                    {firstRacerColumnUI}
                    {secondRacerColumnUI}
                    {thirdRacerColumnUI}
                </div>
            </div>
            <div className={style.betButtons}>
                <ComplexBetButtons store={this.props.store}/>
            </div>
        </div>);
    }
}

export default connect(mapStateToProps)(ComplexRacersList);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/modules/racing/containers/complexRacersList.js